// src/App.js
'use client';
import { useEffect, useState } from 'react';
import AdminLayout from './pages/AdminLayout';
import LoginPage from './pages/LoginPage';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem('isLoggedIn');
    setIsLoggedIn(stored === 'true');
  }, []);

  const handleLoggedIn = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    setIsLoggedIn(false);
  };

  return isLoggedIn ? (
    <AdminLayout onLogout={handleLogout} />
  ) : (
    <LoginPage onLoggedIn={handleLoggedIn} />
  );
}

export default App;